export const STORY_POINTS = {
  UNESTIMATED: -1,
  ZERO: 0,
  ONE: 1,
  TWO: 2,
  THREE: 3,
}

export const mapStoryPoints = (storyPoint: StoryPoints): string => {
  switch (storyPoint) {
    case STORY_POINTS.UNESTIMATED:
      return 'Unestimated'
    case STORY_POINTS.ZERO:
    case STORY_POINTS.ONE:
      return `${storyPoint} Point`
    default:
      return `${storyPoint} Points`
  }
}
